import namaste from '../../assets/images/namaste.svg'

export default ({ loading = false }) => {
    if( !loading ) return <></>
    return(
        <div style={{  position: "fixed", top: "0%", width: "100vw", height: "100vh", background: "#000000b5", zIndex: 9 }}>
            <div className=' d-flex flex-column align-items-center position-absolute' style={{ top: "calc(50% - 35px)", right: "calc(50% - 35px)" }}>
                <img src={namaste} className='mb-3 rounded-circle' style={{ width: "70px", height: "70px",  }} />
                <div className="loader"></div>
            </div>
        </div>
    )
}